import type { ImageWidget } from "~/types/widgets"
import Image from "~/components/ui/Image"

export interface Item {
    /**
     * @title Nome
     */
    label?: string

    /**
     * @title Imagem
     */
    image: ImageWidget

    /**
     * @title Texto alternativo
     */
    alt?: string

    /**
     * @title Link
     */
    url?: string
}

export interface Props {
    /**
     * @title Título
     */
    title?: string

    /**
     * @title Itens
     */
    items: Item[]

    /**
     * @title Imagem de fundo
     */
    backgroundImage?: ImageWidget
}

export default function Sets({ title, items, backgroundImage }: Props) {
    return (
        <div className='py-12' style={{ backgroundImage: `url(${backgroundImage})` }}>
            <div className='max-w-[1810px] mx-auto font-lato grid gap-8'>
                {title && (
                    <h2 className='text-white text-[48px] text-center font-black resale-lingerie-scale-animation'>
                        {title}
                    </h2>
                )}

                <ul className='flex flex-wrap justify-center items-start gap-12'>
                    {items.map((item) => (
                        <li>
                            <a className='grid justify-items-center gap-4' href={item.url}>
                                <Image
                                    className='mb-2 rounded-full aspect-square object-cover'
                                    src={item.image}
                                    alt={item.alt}
                                    width={320}
                                    height={320}
                                    loading='lazy'
                                />

                                <h3 className='text-white text-lg resale-lingerie-scale-animation'>
                                    {item.label}
                                </h3>

                                <button
                                    type='button'
                                    className='w-32 h-12 rounded-full bg-white text-[#8a1538] text-[18px] text-center font-black uppercase flex justify-center items-center transition-colors duration-300 resale-lingerie-scale-animation hover:bg-black hover:text-white lg:text-[15px]'
                                >
                                    Comprar
                                </button>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}
